import { render, staticRenderFns } from "./build.vue?vue&type=template&id=c41e52bc&scoped=true&"
import script from "./build.vue?vue&type=script&lang=js&"
export * from "./build.vue?vue&type=script&lang=js&"
import style0 from "./build.vue?vue&type=style&index=0&id=c41e52bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c41e52bc",
  null
  
)

export default component.exports